import AddOpsManager from "../OpsMangerManagement/addOpsManager";
import AllOpsManager from "../OpsMangerManagement/allOpsManager";

function ClusterLeader() {
  return (
  <>
    <h1>Welcome to Cluster Leader Management</h1>
    <AddOpsManager role={"CLUSTER_LEADER"} />
    <AllOpsManager role={"CLUSTER_LEADER"} />
  </>
);
}

export default ClusterLeader